import * as React from 'react';
import { observer, inject } from 'mobx-react';
import moment = require('moment');
import { ILeadNotesGroupWithIndex } from './LeadNotes';
import { LeadNote } from './Note';
import { computed } from 'mobx';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./LeadNotesGroup.css');

// Props
interface ILeadNotesGroupProps extends IAppOnlyStore {
  group: ILeadNotesGroupWithIndex;
}

// Component
@inject('store')
@observer
export class LeadNotesGroup extends React.Component<ILeadNotesGroupProps, {}> {
  @computed private get date(): moment.Moment {
    return moment(this.props.group.date);
  }

  @computed private get isToday(): boolean {
    return this.date.isSame(this.props.store.utilities.now, 'day');
  }

  @computed private get isYesterday(): boolean {
    return this.date.isSame(
      this.props.store.utilities.now.subtract(1, 'day'),
      'day'
    );
  }

  @computed private get isTwoDaysAgo(): boolean {
    return this.date.isSame(
      this.props.store.utilities.now.subtract(2, 'day'),
      'day'
    );
  }

  @computed private get isThreeDaysAgo(): boolean {
    return this.date.isSame(
      this.props.store.utilities.now.subtract(3, 'day'),
      'day'
    );
  }

  @computed
  private get dateFormatted(): string {
    return this.isToday
      ? 'Today'
      : this.isYesterday
      ? 'Yesterday'
      : this.isTwoDaysAgo
      ? 'Two days ago'
      : this.isThreeDaysAgo
      ? 'Three days ago'
      : this.date.format('MMMM Do, YYYY');
  }

  public render() {
    const {
      group: { date: dateIsoString, notes },
    } = this.props;

    return (
      <div key={dateIsoString} className={s.notesGroup}>
        <div className={s.notesGroupDate}>
          <p>{this.dateFormatted}</p>
          <hr />
        </div>

        <div className={s.notesGroupList}>
          {notes.map((info, i) => (
            <LeadNote key={info.id} noteInfo={info} index={info.index} />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.tsx